import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageSlotModule } from '@spartacus/storefront';
import { ConfigModule, I18nModule } from '@spartacus/core';
import { PrimengModule } from '../primeng/primeng.module';
import { SGRESharedModule } from '../../SGRE-shared/SGRE-shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
  TranslateStore,
} from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { HttpBackend } from '@angular/common/http';

import { CustomRouteGuard } from '../../SGRE-shared/services/guard/msal.guard';

import { MyProfileDetailComponent } from './Components/my-profile-detail/my-profile-detail.component';
import { MyProfileTableComponent } from './Components/my-profile-table/my-profile-table.component';
// import { MyProfileStoreModule } from './store/my-profile-store.module';
import { effects } from '../my-profile/store/effects/index';
import { MY_PROFILE_FEATURE } from './store/my-profile-state';

import { customReducers } from './store/reducers/index';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';


export function HttpLoaderFactory(http: HttpBackend) {
  return new MultiTranslateHttpLoader(http, ['/public/i18n/core/', '/public/i18n/vendors/']);
}

@NgModule({
  declarations: [
    MyProfileDetailComponent,
    MyProfileTableComponent
  ],
  imports: [
    CommonModule,
    PageSlotModule,
    PrimengModule,
    SGRESharedModule,
    FormsModule,
    ReactiveFormsModule,
    StoreModule.forFeature(MY_PROFILE_FEATURE, customReducers),
    EffectsModule.forFeature(effects),
    ConfigModule.withConfig({
      cmsComponents: {
        MyProfileDetails: {
          component: () => import('./Components/my-profile-detail/my-profile-detail.component').then(m => m.MyProfileDetailComponent),
          guards: [CustomRouteGuard]
        },
        MyProfileLegalEntityTable: {
          component: () => import('./Components/my-profile-table/my-profile-table.component').then(m => m.MyProfileTableComponent),
          guards: [CustomRouteGuard]
        }
      }
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpBackend]
      }
    }),
    I18nModule,
    // MyProfileStoreModule
  ],
  providers: [
    TranslateService,
    { provide: TranslateStore }
  ]
})
export class MyProfileModule { }